import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('my-modal', {
    attrs: {
      "data-sign": "finance_reconciliation_bill_billing_deadline_rule_modal",
      "width": 600,
      "title": _vm.t('开票期限规则')
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('my-table', {
    attrs: {
      "bordered": "",
      "columns": _vm.columns,
      "data-source": _vm.dataList,
      "pagination": false,
      "row-key": function (record, index) {
        return index;
      }
    },
    scopedSlots: _vm._u([{
      key: "deadline_days",
      fn: function (ref) {
        var record = ref.record;
        return _vm._l(record.deadline_config_detail_list, function (item) {
          return _c('div', {
            key: item.invoice_deadline_type
          }, [item.invoice_deadline_type === '1' ? _c('span', [_vm._v("/")]) : item.invoice_deadline_type === '2' ? _c('span', [_vm._v(_vm._s(_vm.t('账单出具日')) + "T + " + _vm._s(item.deadline_days || '--'))]) : item.invoice_deadline_type === '3' ? _c('span', [_vm._v(_vm._s(_vm.t('账务日期次月')) + " " + _vm._s(item.deadline_days || '--') + " " + _vm._s(_vm.t('号')))]) : _c('span', [_vm._v(_vm._s('--'))])]);
        });
      }
    }, {
      key: "country_code",
      fn: function (ref) {
        var record = ref.record;
        return [_vm._v(" " + _vm._s(_vm.getCountryText(record.country_code) || '--') + " ")];
      }
    }])
  })], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "type": "primary",
      "data-sign": "finance_reconciliation_bill_billing_deadline_rule_confirm",
      "fbu-analyse-name": $t("\u77E5\u9053\u4E86")
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v(_vm._s(_vm.t('知道了')))])], 1)], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };